import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from './authSlice';
import { authApi } from './api/authApi';
import { studentApi } from './api/studentApi';
import { parentApi } from './api/parentApi';
import { trainerApi } from './api/trainerApi';
import { schoolAdminApi } from './api/schoolAdminApi';
import { masterAdminApi } from './api/masterAdminApi';
import { masterAdminTimetableApi } from './api/masterAdminTimetableApi';
import { trainerTimetableApi } from './api/trainerTimetableApi';
import { masterAdminMonitoringApi } from './api/masterAdminMonitoringApi';
import { schoolAdminTimetableApi } from './api/schoolAdminTimetableApi';
import { schoolAdminMonitoringApi } from './api/schoolAdminMonitoringApi';
import { parentTimetableApi } from './api/parentTimetableApi';
import { studentTimetableApi } from './api/studentTimetableApi';
import { trainerSessionFlowApi } from './api/trainerSessionFlowApi';
import { curriculumPlanApi } from './api/curriculumPlanApi';
import { skillInsightsApi } from './api/skillInsightsApi';
import { salesApi } from './api/salesApi';
import { opsApi } from './api/opsApi';
import { dailyReportApi } from './api/dailyReportApi';

export const store = configureStore({
	reducer: {
		auth: authReducer,
		[authApi.reducerPath]: authApi.reducer,
		[studentApi.reducerPath]: studentApi.reducer,
		[parentApi.reducerPath]: parentApi.reducer,
		[trainerApi.reducerPath]: trainerApi.reducer,
		[schoolAdminApi.reducerPath]: schoolAdminApi.reducer,
		[masterAdminApi.reducerPath]: masterAdminApi.reducer,
		[masterAdminTimetableApi.reducerPath]: masterAdminTimetableApi.reducer,
		[trainerTimetableApi.reducerPath]: trainerTimetableApi.reducer,
		[masterAdminMonitoringApi.reducerPath]: masterAdminMonitoringApi.reducer,
		[schoolAdminTimetableApi.reducerPath]: schoolAdminTimetableApi.reducer,
		[schoolAdminMonitoringApi.reducerPath]: schoolAdminMonitoringApi.reducer,
		[parentTimetableApi.reducerPath]: parentTimetableApi.reducer,
		[studentTimetableApi.reducerPath]: studentTimetableApi.reducer,
		[trainerSessionFlowApi.reducerPath]: trainerSessionFlowApi.reducer,
		[curriculumPlanApi.reducerPath]: curriculumPlanApi.reducer,
		[skillInsightsApi.reducerPath]: skillInsightsApi.reducer,
		[salesApi.reducerPath]: salesApi.reducer,
		[opsApi.reducerPath]: opsApi.reducer,
		[dailyReportApi.reducerPath]: dailyReportApi.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware()
			.concat(authApi.middleware)
			.concat(studentApi.middleware)
			.concat(parentApi.middleware)
			.concat(trainerApi.middleware)
			.concat(schoolAdminApi.middleware)
			.concat(masterAdminApi.middleware)
			.concat(masterAdminTimetableApi.middleware)
			.concat(trainerTimetableApi.middleware)
			.concat(masterAdminMonitoringApi.middleware)
			.concat(schoolAdminTimetableApi.middleware)
			.concat(schoolAdminMonitoringApi.middleware)
			.concat(parentTimetableApi.middleware)
			.concat(studentTimetableApi.middleware)
			.concat(trainerSessionFlowApi.middleware)
			.concat(curriculumPlanApi.middleware)
			.concat(skillInsightsApi.middleware)
			.concat(salesApi.middleware)
			.concat(opsApi.middleware)
			.concat(dailyReportApi.middleware),
});

// Enable refetchOnFocus / refetchOnReconnect
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
